import {NgModule} from '@angular/core';
import {MxButtonModule} from 'mx-core';
import {PrlErrorPageRoutingModule} from './prl-error-page-routing.module';
import {PrlErrorPageComponent} from './prl-error-page/prl-error-page.component';
import {SharedModule} from '../../shared/shared.module';
import {PrlLanguageModule} from '../prl-language/prl-language.module';

@NgModule({
    imports: [
        SharedModule,
        PrlErrorPageRoutingModule,
        MxButtonModule,
        PrlLanguageModule
    ],
    declarations: [PrlErrorPageComponent]
})
export class PrlErrorPageModule {
}

